import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as DashboardModels from '../../models/dashboard/dashboard';
import { EnvironmentService } from '../environment.service';
import { Observable } from 'rxjs';
import * as Models from '../../models/commonModels';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }



  public getWebPageList(Search: DashboardModels.WebPageSearchRequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<DashboardModels.WebPageModel>>(`${this.environmentService.getApiURL()}/dashboard/webpage-list`, Search, options);
  }

  public getWebPageActiveList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.get<Models.ResponseList<DashboardModels.WebPageModel>>(`${this.environmentService.getApiURL()}/dashboard/webpage-active-list`, options);
  }

  public getWebPage(WebPage: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DashboardModels.WebPageModel>>(`${this.environmentService.getApiURL()}/dashboard/webpage-get`, WebPage, options);
  }

  public setWebPage(WebPage: Models.Request<DashboardModels.WebPageModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DashboardModels.WebPageModel>>(`${this.environmentService.getApiURL()}/dashboard/webpage-set`, WebPage, options);
  }

  public deletetWebPage(WebPage: Models.Request<DashboardModels.WebPageModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DashboardModels.WebPageModel>>(`${this.environmentService.getApiURL()}/dashboard/webpage-delete`, WebPage, options);
  }



  public getWebPageTypeList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<DashboardModels.WebPageTypeModel>>(`${this.environmentService.getApiURL()}/dashboard/webpage-types`, options);
  }




  public getDownloadList(Search: DashboardModels.DownloadSearchRequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<DashboardModels.DownloadModel>>(`${this.environmentService.getApiURL()}/dashboard/download-list`, Search, options);
  }

  public getDownloadActiveList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.get<Models.ResponseList<DashboardModels.DownloadModel>>(`${this.environmentService.getApiURL()}/dashboard/download-active-list`, options);
  }

  public getDownload(WebPage: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DashboardModels.DownloadModel>>(`${this.environmentService.getApiURL()}/dashboard/download-get`, WebPage, options);
  }

  public setDownload(WebPage: Models.Request<DashboardModels.DownloadModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DashboardModels.DownloadModel>>(`${this.environmentService.getApiURL()}/dashboard/download-set`, WebPage, options);
  }

  public deletetDownload(WebPage: Models.Request<DashboardModels.DownloadModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DashboardModels.DownloadModel>>(`${this.environmentService.getApiURL()}/dashboard/download-delete`, WebPage, options);
  }

  public setDownloadDocument(Download: Models.Request<DashboardModels.DownloadModel>, File: File) {

    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "multipart/form-data")
      .set("Accept", "application/json");

    const options = { headers: httpHeaders };

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);
    formData.append("DownloadId", Download.Item.DownloadId.toString());
    formData.append("RequestSignature", Download.RequestSignature.toString());

    return this.httpClient.post<Models.Response<DashboardModels.DownloadModel>>(`${this.environmentService.getApiURL()}/dashboard/set-download-document`, formData);
  }

  public getDownloadDocument(Download: Models.Request<DashboardModels.DownloadModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };
    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/dashboard/get-download-document`, Download, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }


  public getTyreChange(): Observable<DashboardModels.TyreChangeObjectModel> {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.get<DashboardModels.TyreChangeObjectModel>(`${this.environmentService.getApiURL()}/dashboard/tyre-change`, options);
  }



  public getDownloadTypeList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<DashboardModels.DownloadTypeModel>>(`${this.environmentService.getApiURL()}/dashboard/download-types-list`, options);
  }
  
  public getDownloadType(WebPage: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DashboardModels.DownloadTypeModel>>(`${this.environmentService.getApiURL()}/dashboard/download-type-get`, WebPage, options);
  }

  public setDownloadType(WebPage: Models.Request<DashboardModels.DownloadTypeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DashboardModels.DownloadTypeModel>>(`${this.environmentService.getApiURL()}/dashboard/download-type-set`, WebPage, options);
  }

  public deletetDownloadType(WebPage: Models.Request<DashboardModels.DownloadTypeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DashboardModels.DownloadTypeModel>>(`${this.environmentService.getApiURL()}/dashboard/download-type-delete`, WebPage, options);
  }
}



